export const tableLocale = {
    emptyText: 'Sin información',
};